<template>
  <div class="typhoon-by-map" v-show="params.flag">
    <!-- 台风面板 -->
    <TyphoonInfo
      ref="typhooninfoRef"
      :typhoonInfo="typhoonInfo"
      @clickTyphoonInfo="clickTyphoonInfo"
    ></TyphoonInfo>

    <!-- 选择台风的显示和隐藏 -->
    <div
      class="check-box"
      v-show="allTyphoonReslt.length > 0"
      :style="{ zIndex: zIndex }"
    >
      <div class="check-header">
        <img src="@/assets/images/矩形备份 9.png" alt="" />
        台风
      </div>
      <div class="select-box">
        <div
          class="check-content check-content1 demo"
          v-show="allTyphoonReslt.length > 0"
        >
          <div class="select-header">{{ year }}年台风列表</div>
          <el-checkbox-group
            class="demo"
            v-model="typhoonTypes"
            @change="typhoonTypeChange"
          >
            <el-checkbox
              :label="item.tsId"
              v-for="item in allTyphoonReslt"
              :key="item.tsId"
              >{{ item.intlId }} {{ item.tscName }}</el-checkbox
            >
          </el-checkbox-group>
        </div>
        <div class="check-content demo" v-if="typhoonObj[typhoonTypes[0]]">
          <el-checkbox-group
            class="demo"
            v-model="checkList"
            @change="typhoonTypeChange1"
          >
            <el-checkbox
              v-show="Object.keys(typhoonObj[typhoonTypes[0]]).includes(key)"
              :label="key"
              v-for="(item, key) in typeNameObj"
              :key="key"
            >
              <div class="line-color">
                {{ typeNameObj[key] }}
                <span
                  class="line"
                  :style="{
                    'border-bottom': `0.14vw dashed ${typeNameColor[key]}`,
                  }"
                ></span>
              </div>
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </div>

      <div
        class="table-box"
        v-show="checkList.length > 0"
        :style="{ zIndex: zIndex }"
      >
        <div class="table-header">
          <div class="item">
            <span v-for="(item, index) in headerData" :key="index">{{
              item
            }}</span>
          </div>
        </div>

        <div class="content demo">
          <div class="item" v-for="(item, index) in tableData" :key="index">
            <span>{{ item.name }}</span>
            <span>{{ item.distance0 ? item.distance0 : "" }}</span>
            <span v-if="item.distance1">{{ item.distance1 }}</span>
            <span v-if="item.distance2">{{ item.distance2 }}</span>
            <span v-if="item.distance3">{{ item.distance3 }}</span>
            <span v-if="item.distance4">{{ item.distance4 }}</span>
            <span v-if="item.distance5">{{ item.distance5 }}</span>
          </div>
        </div>
      </div>

      <!-- 台风等级 -->
      <div class="typhoon-level">
        <div class="title">台风等级</div>
        <div class="level-box">
          <div
            class="level-item"
            v-for="(item, index) in typhoonLevel"
            :key="index"
          >
            <div class="point" :style="{ background: item.color }"></div>
            <div class="name">{{ item.name }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TyphoonInfo from "@/components/TyphoonInfo";

import Typhoon from "@/plugins/map2d/Typhoon";
import VectorLayer from "ol/layer/Vector";
import Overlay from "ol/Overlay";
import { Style, Stroke, Fill, Icon, Text } from "ol/style";
import { LineString, MultiLineString, Point } from "ol/geom";
import { Vector, Vector as VectorSource } from "ol/source";
import { Feature } from "ol";

import { apiData } from "../api/index";
import { mapState } from "vuex";
import { geometry } from "@turf/helpers";

// import { getDistance } from '@/utils/tool'

export default {
  props: ["params"],
  data() {
    return {
      allTyphoonReslt: [],
      typhoonTypes: [],
      checkList: [],
      typhoonLayers: [],
      typhoonCurrentPoints: [],
      typhoonInfo: {},
      typhoonObj: {},
      lastPoint: {},
      typhonOverlay: null,
      warnLineLayer: null,
      rangeFindingLayer: null,
      tableData: [],
      headerData: ["项目点位", "(距离)"],
      zIndex: 0,
      typeNameObj: {
        BCGZ: "广州台",
        RJTD: "日本",
        BABJ: "北京",
        VHHH: "香港",
        PGTW: "美国",
        GZRD: "广州热",
      },
      typeNameColor: {
        RJTD: "#FF4050 ",
        BABJ: "#FFBF57",
        VHHH: "#1044FF",
        PGTW: "#AA49EA",
        BCGZ: "#5CC1C2",
        GZRD: "#FFF",
      },
      typhoonLevel: [
        { name: "热带低压", color: "#00FF05" },
        { name: "热带风暴", color: "#0264FF" },
        { name: "强热带风暴", color: "#EEEB06" },
        { name: "台风", color: "#FFAC04" },
        { name: "强台风", color: "#FF0302" },
        { name: "超强台风", color: "#F171F9" },
        { name: "6级风圈", color: "#00FF05" },
        { name: "7级风圈", color: "#0000ff" },
        { name: "8级风圈", color: "#ffff00" },
        { name: "10级风圈", color: "#dd7c46" },
        { name: "12级风圈", color: "#ff0000" },
      ],
    };
  },
  watch: {
    "params.flag": {
      handler(newVal) {
        if (newVal) {
          this.warnLineLayer && this.warnLineLayer.setVisible(true);
          this.typhoonLayers.length > 0
            ? this.setTyphoonLayerVisble(true)
            : this.getData();
          this.zIndex = JSON.parse(localStorage.getItem("dialogZIndex"));
          console.log(this.$parent);
          if (
            this.typhoonCurrentPoints &&
            this.typhoonCurrentPoints.length > 0
          ) {
            const point =
              this.typhoonCurrentPoints[this.typhoonCurrentPoints.length - 1];
            this.params.map2d.map
              .getView()
              .setCenter([point.longitude, point.latitude]);
            this.params.map2d.map.getView().setZoom(5);
          }
          this.params.map2d.map.getView().setCenter([113.9, 25.8]);
          this.params.map2d.map.getView().setZoom(5);
          this.$parent.selectMap("影像图", 4);
        } else {
          this.setTyphoonLayerVisble(false);
          this.warnLineLayer.setVisible(false);
          this.clickTyphoonInfo();
          this.$parent.selectMap("业务图1", 0);
          console.log("this.$parent", this.$parent);
          this.$parent.tabItemClick("right-bottom", 3);
          // this.clearLine()
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState("home", ["objsList", "activeCountyId"]),
  },
  mounted() {
    this.$nextTick(() => {
      this.addOverLayer();
      this.drapWarnLine();
    });
  },
  methods: {
    // 获取数据
    async getData() {
      // 获取今年所有的台风数据
      this.allTyphoonReslt = [];
      this.year = new Date().getFullYear();
      let allTyphoonReslt = await apiData.queryAllYearTyphoon(this.year);
      if (allTyphoonReslt.length === 0) {
        this.year = this.year - 1;
        allTyphoonReslt = await apiData.queryAllYearTyphoon(this.year);
      }
      allTyphoonReslt.forEach(async (typhoon, index) => {
        this.allTyphoonReslt.push(typhoon);
        this.getTyphoonData(typhoon);
      });
    },

    drapWarnLine() {
      const data = [
        [
          [
            [121, 25],
            [121, 20.9],
          ],
          [
            [121, 20.9],
            [117, 17.06],
          ],
          [
            [117, 17.06],
            [109.5, 17],
          ],
        ],
        [
          [
            [118, 25],
            [126, 25],
          ],
          [
            [126, 25],
            [126, 21],
          ],
          [
            [126, 21],
            [119, 14],
          ],
          [
            [119, 14],
            [109.5, 14],
          ],
          [
            [109.5, 14],
            [109.5, 18],
          ],
        ],
      ];
      const colors = ["red", "yellow"];
      const features = [];
      data.forEach((arr, index) => {
        const feature = new Feature({
          geometry: new MultiLineString(arr),
        });
        feature.setStyle(
          new Style({
            stroke: new Stroke({
              color: colors[index],
              width: 1,
            }),
          })
        );
        features.push(feature);
      });
      const vectorSource = new Vector();
      vectorSource.addFeatures(features);
      const warnLineLayer = new VectorLayer({
        source: vectorSource,
        zIndex: 9999,
      });
      this.params.map2d.map.addLayer(warnLineLayer);
      this.warnLineLayer = warnLineLayer;
    },

    // 根据tsid获取台风点数据
    async getTyphoonData(typhoon) {
      const tsId = typhoon.tsId;
      let flag = false;
      if (this.typhoonObj[tsId]) {
        return "";
      }
      const allTyphoons = await apiData.queryTyphoonPoints(
        this.year,
        typhoon.tsId
      );
      this.typhoonObj[tsId] = allTyphoons;
      for (const key in allTyphoons) {
        allTyphoons[key].fore.map((item) => {
          item.type = "forecast";
          item.tscName = typhoon.tscName;
          item.tcRank = item.tcRank.replace(" ", "").toLocaleUpperCase();
          return item;
        });

        if (key !== "BCGZ") {
          allTyphoons[key].obs = [];
        }

        allTyphoons[key].obs.map((item, index) => {
          if (index === 0) {
            // 筛选小于48小时的台风
            const nowTime = Date.now();
            const pointTime = new Date(item.ddateTime).getTime();
            if (nowTime - pointTime < 86400000 * 2) {
              flag = true;
            }
          }
          item.tscName = typhoon.tscName;
          item.tcRank = item.tcRank.replace(" ", "").toLocaleUpperCase();
          return item;
        });

        if (allTyphoons[key].fore.length === 0) {
          delete allTyphoons[key];
        } else {
          allTyphoons[key].data = [
            ...allTyphoons[key].obs.reverse(),
            ...allTyphoons[key].fore,
          ];
        }
      }

      // this.typhoonTypes = [this.allTyphoonReslt[0].tsId]
      console.log(typhoon);
      if (flag) {
        this.typhoonTypes = [tsId];
        this.typhoonTypeChange();
      }
    },

    // 设置缓存中的台风的显示和隐藏
    setTyphoonLayerVisble(flag) {
      if (flag) {
        this.typhoonTypeChange();
      } else {
        this.typhoonLayers.forEach((layer) => {
          layer.setVisible(false);
        });
      }
    },
    typhoonTypeChange1() {
      setTimeout(() => {
        this.caluTyphoonTableDistance();
      }, 500);

      this.typhoonLayers.forEach((layer) => {
        layer.setVisible(false);
      });
      const tsId = this.typhoonTypes[0];
      this.checkList.forEach((type) => {
        const layerName = tsId + type + "Layer";
        let flag = false;
        this.typhoonLayers.forEach((layer) => {
          const layerName1 = layer.get("tsId");
          if (layerName === layerName1) {
            layer.setVisible(true);
            flag = true;
          }
        });
        if (flag) return;
        const typhoonPoints = this.typhoonObj[tsId][type];
        const { vectorSource, lastPoint } = new Typhoon(
          (pointData) => {
            // 对台风点点击时的操作
            this.typhoonInfo = JSON.parse(JSON.stringify(pointData));
            this.typhoonInfo.name =
              pointData.tscName + "-" + this.typeNameObj[type];
            this.typhoonInfo.longitude = this.typhoonInfo.longitude.slice(0, 7);
            this.typhoonInfo.latitude = this.typhoonInfo.latitude.slice(0, 6);
            this.typhoonInfo.windSpeed = this.typhoonInfo.windSpeed.slice(0, 6);
            const coordinate = [
              Number(pointData.longitude),
              Number(pointData.latitude),
            ];
            this.typhonOverlay.setPosition(coordinate);
          },
          typhoonPoints.data,
          require("@/assets/images/typhoon.gif"),
          this.typeNameColor[type]
        );
        console.log("typhoonPoints.data", typhoonPoints.data);
        console.log("lastPoint", lastPoint);
        const typhoonLayer = new VectorLayer({ zIndex: 99 });
        typhoonLayer.setSource(vectorSource);
        typhoonLayer.set("tsId", layerName);
        typhoonLayer.set("type", type);
        typhoonLayer.set("lastPoint", lastPoint);
        this.params.map2d.map.addLayer(typhoonLayer);
        this.typhoonLayers.push(typhoonLayer);
        // 跳转到最后点位
        if (typhoonPoints.data && typhoonPoints.data.length > 0) {
          this.typhoonCurrentPoints = typhoonPoints.data;
          const point = typhoonPoints.data[typhoonPoints.data.length - 1];
          this.params.map2d.map
            .getView()
            .setCenter([point.longitude, point.latitude]);
          this.params.map2d.map.getView().setZoom(5);
          console.log("跳转到", point.longitude, point.latitude);
        }
      });
    },

    typhoonTypeChange() {
      this.clickTyphoonInfo();

      if (this.typhoonTypes.length === 0) {
        this.checkList = [];
        this.typhoonLayers.forEach((layer) => {
          layer.setVisible(false);
        });
        return;
      }

      if (this.typhoonTypes.length > 1) this.typhoonTypes.splice(0, 1);
      // this.checkList = ['BCGZ']
      const types = Object.keys(this.typhoonObj[this.typhoonTypes[0]]);
      if (types.includes("BCGZ")) {
        this.checkList = ["BCGZ"];
      } else {
        this.checkList = [types[0]];
      }
      this.typhoonTypeChange1();
    },

    // 添加overLay
    addOverLayer() {
      const element = this.$refs.typhooninfoRef.$el;
      this.typhonOverlay = new Overlay({
        position: undefined,
        positioning: "bottom-center",
        element: element,
        offset: [0, -30],
        stopEvent: false,
        autoPan: true,
      });
      this.params.map2d.map.addOverlay(this.typhonOverlay);
    },

    caluTyphoonTableDistance() {
      console.log("台风this.objsList", this.objsList);
      this.tableData = [];
      this.objsList.forEach((obj, index1) => {
        const tableitem = {
          name: obj.name,
        };
        let index = 0;
        const tsId = this.typhoonTypes[0];
        this.typhoonLayers.forEach((layer) => {
          const type = layer.get("type");

          if (type !== "BCGZ") return;

          const layerName = tsId + type + "Layer";
          // console.log(headerName, layer.get('tsId'))
          if (
            layer.get("tsId") === layerName &&
            this.checkList.includes(type)
          ) {
            const distance = "distance" + index;
            index = index + 1;
            const lastPoint = layer.get("lastPoint");

            if (layer.get("tsId") === layerName) {
              const lastPoint = layer.get("lastPoint");
              const s = this.getDistance(
                [Number(lastPoint.longitude), Number(lastPoint.latitude)],
                [obj.lon, obj.lat]
              );
              tableitem[distance] = s + "(km)";
            }
          }
        });
        this.tableData.push(tableitem);
      });
    },

    // 获取两点之间的距离
    getDistance(pointA, pointB) {
      const getRad = (d) => (d * Math.PI) / 180.0; // 经纬度转换成三角函数中度分表形式
      const radLat1 = getRad(parseFloat(pointA[1]));
      const radLat2 = getRad(parseFloat(pointB[1]));
      const a = radLat1 - radLat2;
      const b = getRad(parseFloat(pointA[0])) - getRad(parseFloat(pointB[0]));
      let s =
        2 *
        Math.asin(
          Math.sqrt(
            Math.pow(Math.sin(a / 2), 2) +
              Math.cos(radLat1) *
                Math.cos(radLat2) *
                Math.pow(Math.sin(b / 2), 2)
          )
        );
      s = s * 6378137; // 地球半径(米);
      return Math.floor(s / 1000);
    },

    // 获取线段中间的经纬度
    getCenterPotion(pointA, pointB) {
      const lat = (pointA[0] + pointB[0]) / 2;
      const lon = (pointA[1] + pointB[1]) / 2;
      return [lat, lon];
    },
    // 关闭台风面板
    clickTyphoonInfo() {
      this.typhonOverlay && this.typhonOverlay.setPosition(undefined);
    },
  },
  components: {
    TyphoonInfo: TyphoonInfo,
  },
};
</script>
<style lang="less" scoped>
.check-box {
  position: fixed;
  // width: 10.42vw
  min-width: 19.53vw;
  left: 1.09vw;
  top: 17vh;
  background: rgba(13, 66, 112, 0.8);
  border-radius: 0.63vw;
  // box-shadow: 0px 2px 17px 0px rgba(0, 0, 0, 0.5), inset 0px 0px 77px 0px rgba(100, 184, 248, 1);

  // border-image: linear-gradient(135deg, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.5)) 1 1;
  .check-header {
    display: flex;
    align-items: center;
    height: 2.5vw;
    padding-left: 0.68vw;
    font-weight: 600;
    line-height: 2.5vw;
    font-size: 0.84vw;
    color: #fff;
    border-top-right-radius: 0.63vw;
    border-top-left-radius: 0.63vw;
    background: rgba(19, 72, 121, 0.69);

    img {
      margin-right: 0.52vw;
    }
  }

  .select-box {
    display: flex;
    padding: 0.52vw 0.73vw;

    .check-content {
      display: flex;
      flex-direction: column;
      flex: 1;
      height: 20vh;
      overflow: hidden;
      overflow-y: auto;
      padding-left: 0.68vw;
      background: #0d4270;
      border-radius: 6px;

      .select-header {
        background: #114675;
        color: #fff;
        height: 2.29vw;
        line-height: 2.29vw;
        font-size: 0.83vw;
        font-weight: 600;
      }

      .el-checkbox-group {
        display: flex;
        flex-direction: column;
        overflow: auto;
      }

      /deep/ .el-checkbox__inner {
        // display: none;
      }

      /deep/ .el-checkbox__label {
        color: #fff;
        line-height: 1.82vw;
        font-size: 0.73vw;
      }

      .line-color {
        display: flex;
        align-items: center;

        .line {
          margin-left: 0.52vw;
          width: 1.04vw;
        }
      }
    }

    .check-content1 {
      margin-right: 0.52vw;
    }
  }

  .btn-box {
    display: flex;

    .btn {
      width: 2.6vw;
      height: 1.56vw;
      background: linear-gradient(204deg, #59acfb 0%, #2d74f5 100%);
      border-radius: 0.32vw;
      border: 0;
      text-align: center;
      line-height: 1.56vw;
      cursor: pointer;
      font-size: 0.73vw;
      color: #ffffff;
      margin: 0.52vw 1.04vw;
    }
  }

  .no-typhoon {
    height: 50px;
    text-align: center;
    line-height: 50px;
  }
}

.table-box {
  display: flex;
  flex-direction: column;
  max-height: 12.38vw;
  overflow: hidden;
  padding: 0 0.73vw 0.52vw;

  // background: #165184;
  // box-shadow: 0px 2px 17px 0px rgba(0, 0, 0, 0.5), inset 0px 0px 77px 0px rgba(100, 184, 248, 1);
  // border-radius: 0.63vw;
  .table-header {
    display: flex;
    height: 44px;
    font-weight: 600;
    font-size: 0.94vw;
    color: #fff;
    background: rgba(17, 70, 117, 1);
  }

  .item {
    display: flex;
    flex: 1;

    span {
      display: inline-block;
      height: 2.29vw;
      flex: 1;
      padding: 0vw 0.26vw;
      line-height: 2.29vw;
      text-align: center;
      flex-shrink: 0;
      font-size: 0.84vw;
      color: #fff;
      overflow: hidden; //超出的文本隐藏
      text-overflow: ellipsis; //溢出用省略号显示
      white-space: nowrap;
    }

    span:ntn-child(1) {
      height: 2.08vw;
      width: 8.25vw;
    }
  }

  .content {
    flex: 1;
    overflow: hidden;
    overflow-y: auto;
    background: rgba(16, 68, 115, 0.58);
  }
}

.typhoon-level {
  position: absolute;
  top: calc(100% + 0.52vw);
  width: 100%;
  color: #ffffff;
  background: #0d4270;
  border-radius: 0.63vw;
  opacity: 0.7;
  border: 0.05vw solid;

  .title {
    margin: 0.78vw 0 0.73vw 0.99vw;
    font-size: 0.83vw;
    font-weight: 600;
  }

  .level-box {
    display: flex;
    flex-wrap: wrap;

    .level-item {
      display: flex;
      align-items: center;
      width: calc(100% / 3);
      box-sizing: border-box;
      padding-left: 1.09vw;
      padding-bottom: 0.83vw;

      .point {
        width: 0.52vw;
        height: 0.52vw;
        margin-right: 0.68vw;
        border-radius: 100%;
      }

      .name {
        font-size: 0.73vw;
      }
    }
  }
}

/deep/.demo::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

/deep/.demo::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: #42506e;
}

/deep/.demo::-webkit-scrollbar-thumb:hover {
  border-radius: 5px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #42506e;
}

/deep/.demo::-webkit-scrollbar-track {
  border-radius: 5px;
  background: #112c45;
}
</style>
